import { Filter } from "./FilterGroup"
import { WearableSensorStatus } from "@/api/SensorsService"
import { AlertSystemConditionType } from "@/types/alertConfigurations"

export const alertFilters: Filter[] = [
   {
      type: null,
      id: "alert-none",
      iconName: "snoozeAlert",
      label: "None",
      checked: true,
   },
   // {
   //    type: AlertSystemConditionType.OUT_OF_BOUNDS,
   //    id: "alert-out-of-bounds",
   //    iconName: "outOfBounds",
   //    label: "Out of bounds",
   //    checked: true,
   // },
   {
      type: AlertSystemConditionType.NO_VITALS,
      id: "alert-no-vitals",
      iconName: "noVitalSign",
      label: "No Vitals",
      checked: true,
   },
   {
      type: AlertSystemConditionType.BROKEN_WEARABLE,
      id: "alert-broken-wearable",
      iconName: "brokenWatch",
      label: "Tamper Alarm",
      checked: true,
   },
]

export const statusFilters: Filter[] = [
   {
      type: WearableSensorStatus.CHARGING,
      id: "status-charging",
      iconName: "batteryCharging",
      label: "Charging",
      checked: true,
   },
   {
      type: WearableSensorStatus.WEARING,
      id: "status-wearing",
      iconName: "batteryHalf",
      label: "Wearing",
      checked: true,
   },
   {
      type: WearableSensorStatus.IDLE,
      id: "status-idle",
      iconName: "clock",
      label: "Idle",
      checked: true,
   },
]
